import React from 'react';
import Container from '@material-ui/core/Container';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Link from '@material-ui/core/Link';
import Search from './Search';

function Copyright() {
  return (
    <Typography variant="body2" style={{marginTop: 50}} color="textSecondary" align="center">
      {'Copyright © '}
      <Link color="inherit" href="https://material-ui.com/">
        Leya
      </Link>{' '}
      {new Date().getFullYear()}
      {'.'}
    </Typography>
  );
}

export default function App() {
  return (
    <Container maxWidth="xl">
      <Box my={4}>
        <Typography variant="h4" component="h1" style={{textAlign: 'center'}} gutterBottom>
          Module files validator
        </Typography>
        <Search />
        <Copyright />
      </Box>
    </Container>
  );
}
